<template>
    <div class="employee-certifications">
        <div class="container" v-if="trainings.length>0">
            <div>
                <span class="title">الدورات</span>
                <span class="title-underline"></span>
            </div>
            <b-row >
                <b-col v-for="training in trainings" :key="training.id" cols="12" md="3">
                    <router-link :to="`/company/`">
                <ImageView
                  :imageFile="training.image.url"
                />
                <div>
                  <p >{{ training.title }}</p>
                </div>
              </router-link>                
            </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import ImageView from "@/components/common/ImageView.vue";

export default {
    name: 'EmployeeCertifications',
    components: { ImageView },
    props:{
      trainings:{
      type: Array,
      default: () => [],
    }},
}
</script>
<style lang="">

</style>
